window.CarrolLaborAPI = new function () {
    "use strict";

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['CarrolLabor']);

    self.getForecastSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/forecast_settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.updateForecastSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/forecast_settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getFixedHoursSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/fixed_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.putFixedHoursSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/fixed_hours', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getClosedDays = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/closed_days', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateClosedDaysSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/closed_days', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getOperatingHoursRules = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateOperatingHoursRule = function (brandId, ruleId, rule) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_hours/' + ruleId, 'PUT', rule)
            .then(function (res) {
                if (res && res.data && res.data.data && (res.status === 200 || res.status === 201)) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.createNewOperatingHoursRule = function (brandId, rule) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_hours', 'POST', rule)
            .then(function (res) {
                if (res && res.data && res.data.data && (res.status === 200 || res.status === 201)) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteOperatingHoursRule = function (brandId, ruleId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!ruleId) {
            throw "No rule id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_hours/' + ruleId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandLaborForecast = function (brandId, startDate, endDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            start_week_date: startDate,
            end_week_date: endDate,
            mode: 'BASIC'
        };

        _protected.request('brands/' + brandId + '/labor_forecasts', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateLaborForecast = function (brandId, generateData) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            start_date: generateData.start_date,
        };

        if (generateData.reset_adjustments) {
            params.reset_adjustments = true;
        } else {
            params.reset_adjustments = false;
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/generate', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLaborForecastForWeek = function (brandId, startDate) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        var params = {
            start_date: startDate
        };

        _protected.request('brands/' + brandId + '/labor_forecasts/week', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateLaborForecastProjections = function (brandId, startDate, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = {
            "start_week_date": startDate.format('YYYY-MM-DD'),
            "adjustment": {
                'id': adjustment
            }
        };


        _protected.request('brands/' + brandId + '/forecast', 'PUT', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAdjustments = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAdjustment = function (brandId, adjustmentId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustmentId) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustmentId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewAdjustment = function (brandId, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'POST', adjustment)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateAdjustment = function (brandId, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustment.id) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustment.id, 'PUT', adjustment)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getCarrolLaborBrandSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

};